import { useAppSelector } from "../../store/hooks";
import { selectTranslatedString } from "../../store/selectors/appSelectors";
import { getStoreKeyFromString } from "../helpers/translateHelpers";
import { NOT_TRANSLATABLE_VALUE } from '../constants';

/**
 * Returns tag function which retrieve translation for existed strings
 * */

export const useTranslate = () => {
    // get existed REACT_CONSTs from store
    const translatedStrings = useAppSelector(selectTranslatedString);

    /**
     * Get template string and returns translated version
     * */
    const t = (...string: any) => {
        let rawStr = Array.isArray(string[0]) ? (string[0] as any)?.raw : string[0];
        let restArgs = [];
        let strSrc = '';

        if (Array.isArray(rawStr)) {
            restArgs = string.slice(1, string.length);
            strSrc = rawStr.join(NOT_TRANSLATABLE_VALUE);
        } else {
            strSrc = rawStr;
        }

        // retrieve a key for finding necessary string
        const key = getStoreKeyFromString(strSrc);
     
        const translatedValueSrc = translatedStrings?.[key];
        
        let translatedRes = '';
              
        const translatedParts = translatedValueSrc?.split(NOT_TRANSLATABLE_VALUE);
        if (translatedParts?.length > 1) {
            for (let i = 0; i < translatedParts.length; i++) {
                translatedRes = `${translatedRes}${translatedParts?.[i] || ''}${restArgs?.[i] || ''}`;
            }
        } else {
            translatedRes = translatedValueSrc;
        }

        // if value not found return original string
        return translatedRes || strSrc;
    }
    return {
        t
    }
}